import getCurrentUserToken from './getCurrentUserToken';

type HeadersType = {
  Authorization: string;
  'Content-Type'?: string;
};

type ResultType = {
  method: string;
  headers: HeadersType;
  body?: string | FormData;
};

const getFetchOptions = async (method: string = 'GET', body?: string | FormData) => {
  const token = await getCurrentUserToken();
  const headers: HeadersType = {
    Authorization: `Bearer ${token}`,
  };

  const result: ResultType = {
    method,
    headers: !(body instanceof FormData) ? { 'Content-Type': 'application/json', ...headers } : headers,
  };

  if (!!body) {
    result.body = body;
  }

  return result;
};

export default getFetchOptions;
